export default __webpack_public_path__ + "static/media/watermark11.f12081d6.png";